import React from 'react';
import BaseIcon, { IconProps } from './Base.icon';

const ChevronLeftIcon = ({ width, height }: IconProps) => {
  return (
    <BaseIcon width={width} height={height} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.348 8.852L9.148 13.652C9.364 13.868 9.664 14 10 14C10.66 14 11.2 13.46 11.2 12.8C11.2 12.464 11.068 12.164 10.852 11.948L6.892 8L10.84 4.052C11.068 3.836 11.2 3.536 11.2 3.2C11.2 2.54 10.66 2 10 2C9.664 2 9.364 2.132 9.148 2.348L4.348 7.148C4.132 7.364 4 7.664 4 8C4 8.336 4.132 8.636 4.348 8.852Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default ChevronLeftIcon;
